import React from 'react'
import { useParams } from 'react-router-dom'
import { useBuyContext } from '../../../state-management/contexts/BuyContext'
import { OTPVerficationPage } from '../../OTP/OTPVerficationPage'
import { useUserDetails } from '../../../hooks/useUserDetails'

export const BuyOTPPage: React.FC = () => {
  const { isin: isinParam } = useParams<{ isin: string }>()
  const pathIsin = isinParam ?? ''
  const { otpVerificationState, otpVerificationHandlers } = useBuyContext()
  const { userDetails } = useUserDetails()

  return (
    <OTPVerficationPage
      numberOfDigits={6}
      phoneNumber={userDetails?.mobileNumber || ''}
      emailId={userDetails?.emailId || ''}
      isOTPVerified={otpVerificationState.isOTPVerified}
      OTPVerificationFailedCase={otpVerificationState.OTPVerificationFailedCase}
      isOTPVerificationLoading={otpVerificationState.isOTPVerificationLoading}
      isOTPVerificationLimitExceeded={otpVerificationState.isOTPVerificationLimitExceeded}
      handleResendOTP={otpVerificationHandlers.handleResendOTP}
      handleOTPVerification={otpVerificationHandlers.handleOTPVerification}
      inputContainerTestLocator='MFE_ENTER_OTP'
      trackingFund={pathIsin ? { fundIsin: pathIsin } : undefined}
    />
  )
}
